module.exports = __webpack_public_path__ + "static/sunsets-icon-68a09a8ab35797cb3395c18d86cc9501.svg";